import React from "react";

const ActionLoader = () => {
    return (
        <div className="main_actions_loader_item_cont">
            <div className="main_actions_loader_item_cont_title_cont">
                <div className="main_actions_loader_item_cont_title fade-in"></div>
                <div className="main_actions_loader_item_cont_type fade-in"></div>
            </div>
            <div className="main_actions_loader_item_cont_body_cont">
                <div className="main_actions_loader_item_cont_body_cont_item">
                    <div className="main_actions_loader_item_cont_body_cont_item_title fade-in"></div>
                    <div className="main_actions_loader_item_cont_body_cont_item_desc fade-in"></div>
                </div>
                <div className="main_actions_loader_item_cont_body_cont_item">
                    <div className="main_actions_loader_item_cont_body_cont_item_title fade-in"></div>
                    <div className="main_actions_loader_item_cont_body_cont_item_desc fade-in"></div>
                </div>
                <div className="main_actions_loader_item_cont_body_cont_item">
                    <div className="main_actions_loader_item_cont_body_cont_item_title fade-in"></div>
                    <div className="main_actions_loader_item_cont_body_cont_item_desc fade-in"></div>
                </div>
            </div>
            <div className="main_actions_loader_item_cont_footer_cont fade-in"></div>
        </div>
    )
}

export default ActionLoader